import { Component, OnDestroy } from '@angular/core'
import {
  clearErrors,
  HeliosError,
  RootState,
  selectActiveSessionIdentifier,
  selectCurrentUser,
  selectErrors,
  User,
} from '@helios/state-management'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { Store } from '@ngrx/store'
import { Observable, Subject } from 'rxjs'
import { filter, map, take, takeUntil, takeWhile } from 'rxjs/operators'

@Component({
  selector: 'hs-error-log-modal',
  templateUrl: './error-log-modal.component.html',
})
export class ErrorLogModalComponent implements OnDestroy {
  private readonly destroySubject$ = new Subject<void>()
  readonly errorLog$: Observable<HeliosError[]> =
    this.store.select(selectErrors)

  readonly isErrorLogNonEmpty$: Observable<boolean> = this.errorLog$.pipe(
    map(errorLog => errorLog.length > 0),
  )

  constructor(
    readonly activeModal: NgbActiveModal,
    private readonly store: Store<RootState>,
  ) {}

  ngOnDestroy() {
    this.destroySubject$.next()
    this.destroySubject$.complete()
  }

  trackByErrorId(_index: number, item: HeliosError): string {
    return item.id
  }

  onDismissModal() {
    this.activeModal.dismiss()
  }

  onClearErrors() {
    this.store.dispatch(clearErrors())
  }

  async onCopy() {
    const activeSessionId = await this.store
      .select(selectActiveSessionIdentifier)
      .pipe(take(1), takeUntil(this.destroySubject$))
      .toPromise()
    const currentUser = await this.store
      .select(selectCurrentUser)
      .pipe(
        takeUntil(this.destroySubject$),
        takeWhile(user => user == null, true),
        filter((user): user is User => user != null),
      )
      .toPromise()
    const errors = await this.errorLog$.pipe(take(1)).toPromise()

    const errorLog = {
      activeSession: activeSessionId,
      userId: currentUser.clearwaterData?.legacyUserId,
      username: currentUser.clearwaterData?.name,
      errors: errors.slice(),
    }

    await window.navigator.clipboard.writeText(JSON.stringify(errorLog))
  }
}
